import React from "react";
import { Row, Col, Form, Input } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import { allValidation } from "../../../common/constants/Helpers";

const Registration = ({ ...props }) => {
  const { registerForm, isRegisterLoading, handleRegisterClick, handleOnCancelClick } = props;

  return (
    <Form layout="vertical" form={registerForm}>
      <Col xl={8} lg={10} md={24} sm={24} xs={24}>
        <BannerCard title="Enter Account Information">
          <br />
          <Row gutter={[12, 12]}>
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
              <span>Use the Agency ID and Reference Code supplied to you by the Clerk of Court.</span>
            </Col>
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Agency ID" name="AGENCY_ID" rules={allValidation}>
                <Input />
              </Form.Item>
            </Col>
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Reference Code" name="REFERENCE_CODE" rules={allValidation}>
                <Input />
              </Form.Item>
            </Col>
            <Col>
              <CleanButton icon="check" onClick={handleRegisterClick} loading={isRegisterLoading}>
                Continue
              </CleanButton>
            </Col>
            <Col>
              <CleanButton icon="times" onClick={handleOnCancelClick}>
                Cancel
              </CleanButton>
            </Col>
          </Row>
        </BannerCard>
      </Col>
    </Form>
  );
};

export default Registration;
